<template>
  <div>
    <v-app-bar
      id="home-app-bar"
      app
      elevation="1"
      elevate-on-scroll
      height="56"
    >
      <router-link
        to="/"
        class="logo-link"
      >
        <base-img
          :src="logoSrc"
          class="mr-3 d-sm-none"
          contain
          max-width="102"
          width="100%"
        />
      </router-link>

      <router-link
        to="/"
        class="logo-link"
      >
        <base-img
          class="mr-3 hidden-xs-only"
          :src="logoSrc"
          contain
          max-width="120"
          width="100%"
        />
      </router-link>

      <v-spacer />

      <div class="d-flex">
        <!-- 顶部导航 Tab 栏：使用 v-tabs + v-tab 配合 :to 实现路由匹配高亮 -->
        <v-tabs
          class="hidden-sm-and-down"
          optional
          background-color="transparent"
        >
          <template v-for="(item, i) in tabItems">
            <!-- Products tab：鼠标悬停显示分类下拉菜单 -->
            <v-menu
              v-if="item.name === 'Products' && productCategories.length"
              :key="`prod-menu-${i}`"
              open-on-hover
              bottom
              offset-y
              :close-delay="150"
              :open-delay="0"
              :nudge-bottom="2"
              content-class="products-nav-dropdown"
            >
              <template #activator="{ on, attrs }">
                <v-tab
                  :to="item.src"
                  :exact="item.exact"
                  :ripple="false"
                  class="font-weight-bold btnHover"
                  min-width="96"
                  text
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ $t(item.i18n) }}
                  <v-icon
                    small
                    class="ml-1"
                  >
                    {{ icon.down }}
                  </v-icon>
                </v-tab>
              </template>
              <v-list
                dense
                nav
                class="products-nav-dropdown-list"
              >
                <v-list-item
                  v-for="cat in productCategories"
                  :key="cat.value"
                  :to="{ path: item.src, query: { category: cat.value } }"
                >
                  <v-list-item-title class="white--text text-body-2">
                    {{ cat.label }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <!-- 普通 tab -->
            <v-tab
              v-else
              :key="i"
              :to="item.src"
              :exact="item.exact"
              :ripple="false"
              class="font-weight-bold btnHover"
              min-width="96"
              text
            >
              {{ $t(item.i18n) }}
            </v-tab>
          </template>
        </v-tabs>
        <div class="d-flex align-center">
          <v-btn
            class="mr-2 contact-cta hidden-sm-and-down"
            color="primary"
            depressed
            rounded
            :to="{ name: 'Contact', params: { lang: $i18n.locale } }"
          >
            {{ $t('contact.title') }}
          </v-btn>
          <v-menu
            transition="slide-y-transition"
            open-on-hover
            bottom
            offset-y
          >
            <template #activator="{ on, attrs }">
              <v-btn
                text
                color="title"
                class="btnHover"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>
                  {{ icon.translate }}
                </v-icon>
                <v-icon small>
                  {{ icon.down }}
                </v-icon>
              </v-btn>
            </template>
            <v-list
              nav
              dense
            >
              <v-list-item-group
                v-model="langSelected"
                color="title"
              >
                <v-list-item
                  v-for="(item, i) in languages"
                  :key="i"
                  @click="changeLang(item.lang)"
                >
                  <v-list-item-content>
                    <v-list-item-title v-text="item.text" />
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </div>
        <!-- <div class="d-flex align-center">
          <v-btn
            text
            to="/login"
            class="btnHover"
            color="title"
          >
            <v-icon>
              {{ icon.login }}
            </v-icon>
          </v-btn>
        </div> -->
      </div>

      <v-app-bar-nav-icon
        class="hidden-md-and-up"
        @click="drawer = !drawer"
      />
    </v-app-bar>

    <home-drawer
      v-model="drawer"
      :items="navItems"
    />
  </div>
</template>

<script>
  import { mdiTranslate, mdiChevronDown, mdiLogin } from '@mdi/js'
  export default {
    name: 'HomeAppBar',

    components: {
      HomeDrawer: () => import('./Drawer'),
    },

    data: () => ({
      drawer: null,
      customLogoUrl: '',
      productCategories: [],
      icon: {
        translate: mdiTranslate,
        down: mdiChevronDown,
        login: mdiLogin,
      },
      items: [
        {
          name: 'Home',
          i18n: 'nav.home',
          src: '/',
          exact: true, // Home tab 使用精确匹配，避免 /en 匹配到 /en/contact 等子路由
        },
        {
          name: 'Products',
          i18n: 'nav.products',
          src: '/products',
          // children: [
          //   {
          //     name: 'YOOX Anti-Interference Signal Booster',
          //     i18n: 'products.product_1',
          //     src: '/products/1',
          //   },
          //   {
          //     name: 'YOOX S3T',
          //     i18n: 'products.product_2',
          //     src: '/products/2',
          //   },
          // ],
        },
        {
          name: 'Solutions',
          i18n: 'nav.solutions',
          src: '/solutions',
        },
        {
          name: 'About',
          i18n: 'nav.about',
          src: '/about',
        },
        {
          name: 'Partnership',
          i18n: 'nav.partnership',
          src: '/partnership',
        },
        {
          name: 'Blog',
          i18n: 'nav.blog',
          src: '/blog',
        },
        {
          name: 'Contact',
          i18n: 'contact.title',
          src: '/contact',
          tabHidden: true,
        },
      ],
      langSelected: 0,
      languages: [
        {
          lang: 'en',
          text: 'English',
        },
        {
          lang: 'zh',
          text: '简体中文',
        },
        {
          lang: 'ar',
          text: 'العربية',
        },
        {
          lang: 'es',
          text: 'Español',
        },
        {
          lang: 'pt',
          text: 'Português',
        },
        {
          lang: 'fr',
          text: 'Français',
        },
        {
          lang: 'de',
          text: 'Deutsch',
        },
        {
          lang: 'ko',
          text: '한국어',
        },
      ],
    }),

    computed: {
      logoSrc() {
        return this.customLogoUrl || require('@/assets/logo/logo.png')
      },
      navItems() {
        return this.items.map((item) => {
          const mapped = {
            ...item,
            src: this.withLang(item.src),
            exact: item.exact || false,
          }
          if (item.name === 'Products' && this.productCategories.length) {
            // 移动端：将 product_category 注入为子项
            mapped.children = this.productCategories.map(cat => ({
              name: cat.label,
              src: `${this.withLang(item.src)}?category=${encodeURIComponent(cat.value)}`,
            }))
          } else if (item.children) {
            mapped.children = item.children.map((child) => ({
              ...child,
              src: this.withLang(child.src),
            }))
          }
          return mapped
        })
      },
      tabItems() {
        return this.navItems.filter(item => !item.tabHidden)
      },
    },

    watch: {
      '$i18n.locale'() {
        this.syncLangSelected()
        this.loadProductCategories()
      },
    },

    created() {
      this.loadLanguages()
      this.syncLangSelected()
      this.fetchLogo()
      this.loadProductCategories()
    },

    methods: {
      async loadProductCategories() {
        const locale = (this.$i18n.locale || 'en').toLowerCase()
        try {
          const resp = await this.$axios({
            method: 'get',
            url: '/public/dict/data',
            params: { dictType: 'product_category', lang: locale },
          })
          const active = Array.isArray(resp) ? resp.filter(item => item?.status === '0') : []
          if (active.length > 0) {
            this.productCategories = active.map(item => ({
              label: item.dictLabel || item.dictValue,
              value: item.dictValue,
            }))
            return
          }
        } catch {
          // 忽略错误，使用硬编码降级
        }
        // 降级：硬编码默认分类
        this.productCategories = locale.startsWith('zh')
          ? [
            { label: '无人机', value: 'Drone' },
            { label: '抗干扰', value: 'Anti-Jamming' },
            { label: '成像', value: 'Imaging' },
            { label: '反无人机', value: 'Anti-Drone' },
            { label: '无GNSS', value: 'GNSS-Free' },
          ]
          : [
            { label: 'Drone', value: 'Drone' },
            { label: 'Anti-Jamming', value: 'Anti-Jamming' },
            { label: 'Imaging', value: 'Imaging' },
            { label: 'Anti-Drone', value: 'Anti-Drone' },
            { label: 'GNSS-Free', value: 'GNSS-Free' },
          ]
      },
      async fetchLogo() {
        try {
          const resp = await this.$axios({ method: 'get', url: '/public/site-logo' })
          if (resp && resp.url) {
            this.customLogoUrl = resp.url
          }
        } catch {
          // ignore, use default logo
        }
      },
      syncLangSelected() {
        const current = this.$i18n.locale || 'en'
        const index = this.languages.findIndex(item => item.lang === current)
        this.langSelected = index >= 0 ? index : 0
      },
      async loadLanguages() {
        try {
          const resp = await this.$axios({
            method: 'get',
            url: '/public/languages',
          })
          const availableLocales = this.$i18n.availableLocales || []
          const list = (Array.isArray(resp) ? resp : [])
            .filter(item => item.status === '0')
            .sort((a, b) => (a.sort || 0) - (b.sort || 0))
            .map(item => ({ lang: item.dictValue, text: item.dictLabel }))
            .filter(item => availableLocales.includes(item.lang))

          if (list.length > 0) {
            this.languages = list
            localStorage.setItem('sys_language_codes', JSON.stringify(list.map(item => item.lang)))
          }
        } catch (error) {
          // ignore and keep fallback languages
        } finally {
          this.syncLangSelected()
        }
      },
      withLang(path) {
        const lang = this.$i18n.locale || 'en'
        if (!path || path === '/') return `/${lang}`
        return `/${lang}${path}`
      },
      changeLang(lang) {
        this.$i18n.locale = lang
        const segments = this.$route.path.split('/').filter(Boolean)
        const currentLang = segments[0]
        if (currentLang && currentLang.length === 2) {
          segments.shift()
        }
        const rest = segments.length ? `/${segments.join('/')}` : ''
        this.$router.push(`/${lang}${rest}`)
      },
    },
  }
</script>

<style lang="sass">
#home-app-bar
  .v-tabs-slider
    max-width: 24px
    margin: 0 auto

    .v-tab
      &::before
        display: none
  .btnHover:hover
    background: rgba(0, 0, 0, 0.08)

.logo-link
  text-decoration: none
  display: inline-block
  transition: opacity 0.3s ease

// Products 导航下拉菜单
.products-nav-dropdown
  background: rgba(50, 52, 58, 0.72) !important
  backdrop-filter: blur(12px)
  -webkit-backdrop-filter: blur(12px)
  border-radius: 8px !important
  box-shadow: 0 8px 24px rgba(0,0,0,0.28) !important
  overflow: hidden
  // 消除 Vuetify menu 与 activator 之间的间隙，防止悬停移动时菜单消失
  margin-top: -2px !important
  .products-nav-dropdown-list
    background: transparent !important
    padding: 4px 0
    .v-list-item
      min-height: 36px
      border-radius: 6px !important
      margin: 2px 4px
      &:hover
        background: rgba(255, 255, 255, 0.16) !important
      .v-list-item__title
        color: rgba(255, 255, 255, 0.92) !important

.contact-cta
  letter-spacing: 0.5px
</style>
